import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'yz-bottom-btn',
  templateUrl: './yz-bottom-btn.component.html',
  styleUrls: ['./yz-bottom-btn.component.less']
})
export class YzBottomBtnComponent implements OnInit {

  // 自定义样式
  @Input() customStyle = {};

  constructor() {
  }

  ngOnInit() {
  }

  // 返回
  goBack() {
    window.history.back();
  }

  // 前进
  goForward() {
    window.history.forward();
  }
}
